module.exports = __webpack_public_path__ + "img/HotRollFeverPoker_EGM.2c0dafbc.png";